export const applicationJson = "application/json";
export const multiparFormData = "multipart/form-data";
export const FORGOTPASSWORD = "ForgotPassword";
export const AUTH = "Auth";
export const RESETPASSWORD = "ResetPassword";
export const USER = "User";
export const FETCH_DATA = "FetchData";
export const GET_PUBLIC_SPOT = "Spot/public/all";
export const GET_SUBSCRIPTION_PRICES = "SubscriptionPrices";
export const CREATE_FREELANCE_INSTRUCTOR = "FreelanceInstructor";
export const REGISTER_CENTER = "Center";
